module.exports = __webpack_public_path__ + "img/fondo-fabricacion-mobile.0f4d0747.jpg";